module.exports = {
    cancelarContrarreferencia: 'Cancelar Contrarreferência',
    caracterizacaoAtendimento: 'Caracterização do Atendimento',
    caracterizacaoInstituicaoEmissao: 'Identificação da instituição que está emitindo a contrarreferência',
    cid10Principal: 'CID-10 Principal',
    cid10Secundario: 'CID-10 Secundário',
    cidadeUfOrigem: 'Cidade/UF de origem',
    confirmarCancelamento: 'Você tem certeza que deseja essa cancelar a contrarreferência?',
    contrarreferencia: 'Contrarreferência',
    contrarreferenciaAssinadaComSucesso: 'Contrarreferência assinada com sucesso.',
    contrarreferenciaCanceladaComSucesso: 'Contrarreferência cancelada com sucesso.',
    dadosCancelamento: 'Dados do cancelamento',
    envioContrarreferencia: 'Envio de Contrarreferência',
    erroAoCancelarContrarreferencia: 'Erro ao cancelar contrarreferência. Por favor, tente novamente mais tarde.',
    erroAoCarregarContrarreferencia: 'Erro ao carregar contrarreferência para edição.',
    instituicaoOrigem: 'Instituição de origem',
    modalidadeAssistencial: 'Modalidade Assistencial',
    motivoAtendimento: 'Motivo do Atendimento',
    notificacaoAlteracaoContrarreferenciaAssinada: 'Esta contrarreferência já foi assinada anteriormente. Qualquer alteração irá invalidar a assinatura atual, sendo necessário assinar novamente para que as alterações fiquem disponíveis.',
    novaContrarreferencia: 'Nova contrarreferência',
    opcaoInvalida: 'Opção inválida',
    procedencia: 'Procedência',
    procedenciaExplicacao: 'Procedência (Segundo o RAC: Identifica o serviço que encaminhou o indivíduo ou a iniciativa de seu responsável na busca pelo acesso ao serviço de saúde)',
    responsavelEmissao: 'Responsável pela emissão'
}